import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const leadDataClassName = DataClassName.LEAD
const leadEndpoint = PisaDataClassEndpoint.LEAD

export function pisaLeadDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(leadDataClassName, {
    title: leadDataClassName,
    restApi: createPisaRestApiConfig(leadEndpoint),
    attributes,
  })
}
